//Layout.tsx 

import { Route, Routes, useLocation } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { useUserRegistration } from "../../contexts/UserRegistrationContext";
import { useLocalStorageToggle, useMediaQuery } from "../../hooks/common";
import AboutUs from "../../pages/landingPage/AboutUs";
import LandingPage from "../../pages/landingPage/landingPage";
import OnboardingRoutes from "../../routes/OnboardingRoutes";
import Sidebar, {
  MobileSideBar,
} from "../CommonComponents/Navbar/sidebar/sideBar";
import RoutesComponent from "../RoutesComponent";
import MainRouter from "../router";
function Layout() {
  let location = useLocation();
  const user = useUser();
  // const stuffToRender = useStuffToRender();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const userRegistration = useUserRegistration();

  const hideSidebar = location.pathname.startsWith("/launch-page");

  const [sidebar, toggleSidebar, setSidebar] =
    useLocalStorageToggle("mobile-sidebar");
  const closeSidebar = () => setSidebar(false);

  const sidebarToRender = isMobile ? (
    <MobileSideBar open={sidebar} onClose={closeSidebar} />
  ) : (
    <Sidebar />
  );

  let toRender = null;
  if (location.pathname === "/" || location.pathname === "/about") {
    toRender = (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
    );
  } else if (location.pathname.includes("onboarding")) {
    toRender = <OnboardingRoutes />;
  } else {
    toRender = (
      <MainRouter
        sidebar={sidebar}
        toggleSidebar={toggleSidebar}
        hideSidebar={hideSidebar}
        sidebarToRender={sidebarToRender}
      />
    );
  }

  return <>{toRender}</>;
}

export default Layout;
